/* eslint-disable max-len */
import api from './api';

const postWebhook = (data) => api.post(`${process?.env?.REACT_APP_WEBHOOK_URL}/${process?.env?.REACT_APP_WEBHOOK_ID}`, data);

export default postWebhook;
